export const ROOM_CHARGE_PAYMENT_METHOD = 'ROOM_CHARGE'

export const RESTAURANT_ORDER_TYPE = 'RESTAURANT'

export const ROOM_CHARGE_ORDER_TYPES = [RESTAURANT_ORDER_TYPE, 'COUNTER', 'PICKUP']

export const SALES_TRANSFER_STATE_FAILED = 'FAILED'

export const FOLIO_ERROR_STATUS_OPTION = 'SALES_TRANSFER_FAILED'

export const CANCELED_ORDER_STATUSES = ['CANCELED', 'ABORTED']
